import { render } from "./kuaishouaccount.vue?vue&type=template&id=850137dc&scoped=true"
import script from "./kuaishouaccount.vue?vue&type=script&lang=js"
export * from "./kuaishouaccount.vue?vue&type=script&lang=js"

import "./kuaishouaccount.vue?vue&type=style&index=0&id=850137dc&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-850137dc"]])

export default __exports__